import { inferRouteObject } from 'react-router-typed-object';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import {
  DEFAULT_PROMOTION_PAGE,
  PromotionPage,
  Sales,
  SalesPromotionDetailsSearchParams,
  SalesTaskFormSearchParams,
  SalesTasksTableSearchParams,
} from 'src/scenes/Sales/index.ts';
import Status from 'src/scenes/Status/index.ts';

const index = true;

export const salesRouteObject = inferRouteObject({
  path: 'sales',
  children: [
    {
      Component: Sales.Helmet,
      children: [
        { index, Component: Sales.RoleBasedRedirector },
        {
          element: <PrivateRoute roles={Roles.SALESFUNNEL} noAccessComponent={Status.NotFound} />,
          children: [
            {
              children: [
                { path: 'tags', Component: Sales.Settings.SalesfunnelLabels },
                { path: 'sources', Component: Sales.Settings.Sources },
                { path: 'task-topics', Component: Sales.Settings.TaskTopics },
              ],
            },
            {
              path: 'promotions',
              Component: Sales.Promotions.Layout,
              children: [
                { index, element: <Navigate to='./list' replace /> },
                { path: 'list', Component: Sales.Promotions.List },
                { path: 'typeConfig/list', Component: Sales.Promotions.TypeConfigList },
                { path: 'new', Component: Sales.Promotions.Create },
                {
                  path: ':promotionId',
                  Component: Sales.PromotionDetails.Providers,
                  children: [
                    { index, element: <Navigate to={`./${DEFAULT_PROMOTION_PAGE}`} replace /> },
                    {
                      Component: Sales.PromotionDetails.Layout,
                      children: [{ path: ':page', Component: Sales.PromotionDetails.Renderer }],
                    },
                    { path: `${PromotionPage.Accounts}/add`, Component: Sales.Promotions.AddAccounts },
                    { path: `${PromotionPage.Contacts}/add`, Component: Sales.Promotions.AddContacts },
                    { path: 'edit', Component: Sales.Promotions.Edit },
                    { path: 'mailTemplate', Component: Sales.Promotions.MailTemplate },
                  ],
                },
              ],
            },
            {
              path: 'promotions-v2',
              children: [
                { index, Component: Sales.PromotionsV2.Promotions },
                { path: 'type-configs', Component: Sales.PromotionsV2.TypeConfigs },
                { path: 'create', Component: Sales.PromotionsV2.ManagePromotion },
                {
                  path: ':promotionId',
                  Component: Sales.PromotionsV2.PromotionDetails,
                  searchParams: SalesPromotionDetailsSearchParams.parse,
                },
                {
                  path: ':promotionId/add-accounts',
                  Component: Sales.PromotionsV2.PromotionAddAccounts,
                },
                {
                  path: ':promotionId/add-contacts',
                  Component: Sales.PromotionsV2.PromotionAddContacts,
                },
                { path: ':promotionId/edit', Component: Sales.PromotionsV2.ManagePromotion },
                { path: ':promotionId/mail-template', Component: Sales.PromotionsV2.PromotionMailTemplate },
              ],
            },
            {
              path: 'activities',
              children: [
                { index, Component: Sales.Activities.Activities },
                { path: 'create', Component: Sales.Activities.ActivityForm },
                { path: 'edit/:activityId', Component: Sales.Activities.ActivityForm },
              ],
            },
            {
              path: 'comments',
              Component: Sales.Activities.Comments,
            },
            { path: 'touchpoints', element: <Navigate to='../activities' replace /> },
            {
              path: 'tasks',
              searchParams: SalesTasksTableSearchParams.parse,
              children: [
                {
                  element: <PrivateRoute roles={or(Roles.ADMIN, Roles.SALESFUNNEL)} noAccessComponent={Status.NotFound} />,
                  children: [
                    { path: 'create', Component: Sales.Tasks.Form, searchParams: SalesTaskFormSearchParams.parse },
                    { path: 'edit/:taskId', Component: Sales.Tasks.Form },
                    { path: 'details/:taskId', Component: Sales.Tasks.Details },
                    { index, Component: Sales.Tasks.Tables },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
});
